import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import { normalizeSchedule } from '../../utils/weeklyAvailability';
export async function saveWeeklyAvailability(uid, schedule) {
  if (!uid || auth.currentUser?.uid !== uid) throw new Error('Sign in to save your own availability.');
  const normalized = normalizeSchedule(schedule);
  if (!normalized) throw new Error('Invalid weekly schedule.');
  await updateDoc(doc(db, 'users', uid), { availabilitySchedule: normalized, availabilityScheduleUpdatedAt: serverTimestamp(), updatedAt: serverTimestamp() });
  return normalized;
}
